/**
 * Home Controller
 * 홈 페이지 컨트롤러
 */
export class HomeController {
    /**
     * index - 홈 페이지
     */
    index() {
        // 홈 페이지는 Hero 컴포넌트에서 이미 초기화되므로
        // 별도의 초기화 로직이 필요 없으면 빈 객체 반환
        return null;
    }
}
